import { render } from "./ProductionList.vue?vue&type=template&id=5d10a976&scoped=true"
import script from "./ProductionList.vue?vue&type=script&lang=js"
export * from "./ProductionList.vue?vue&type=script&lang=js"

import "./ProductionList.vue?vue&type=style&index=0&id=5d10a976&scoped=true&lang=css"

import exportComponent from "/Users/yllian/RolnnData/Project/m2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d10a976"]])

export default __exports__